/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
import _ from 'lodash';
import {
  setCustomer,
  setAnalysisPageCustomer,
  setIsLoadingLoaded, 
  setCustomerSettingsSource, 
  replaceSettingsForCustomer,
  clear,
} from './actions';
import { ROOT_SLICE } from './constants';
import { initialState } from './initialState';
import {
	selectThisSlice,
	selectIsLoading,
  selectIsLoaded,
  selectCustomer,
  selectCustomerSettingsSource,
} from './selectors';
import TOKEN_UTIL from '../../../../../util/token.customerAppSettings/scanline';

import { getCustomer } from '../../../../../util/user';

const isDefined = v => v !== undefined && v !== null;

// ************
// PARTS
// ************
const reducerParts = {
	[clear]: state => {
		return {
			...state,
			[ROOT_SLICE]: _.cloneDeep(initialState)
		};
	},
  
  [setCustomer]: (state, { payload: { customer } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        customer
			}
		};
  },
  
  [setAnalysisPageCustomer]: (state, { payload: { analysisPageCustomer } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        analysisPageCustomer
			}
		};
  },

	[setIsLoadingLoaded]: (
		state,
		{ payload: { isLoading: newIsLoading, isLoaded: newIsLoaded } }
	) => {
		const rootSlice = selectThisSlice(state);
		const isLoading = selectIsLoading(state);
		const isLoaded = selectIsLoaded(state);

		const CHANGED = {
			isLoading: isDefined(newIsLoading) && newIsLoading !== isLoading,
			isLoaded: isDefined(newIsLoaded) && newIsLoaded !== isLoaded
		};

		if (!CHANGED.isLoaded && !CHANGED.isLoading) {
			return state;
		}

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				isLoadingCustomerSettingsSource: CHANGED.isLoading ? newIsLoading : isLoading,
				isLoadedCustomerSettingsSource: CHANGED.isLoaded ? newIsLoaded : isLoaded
			}
		};
  },
  
  [setCustomerSettingsSource]: (state, { payload: { data } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        customerSettingsSource: data
			}
		};
  },

	[replaceSettingsForCustomer]: (state) => {
		const rootSlice = selectThisSlice(state);
		const customer = selectCustomer(state);
		const source = selectCustomerSettingsSource(state) || {};
		const _appSettingsOverride = source[customer]?.SCANLINE || {};

		const settings = customer === getCustomer() ?
			_.cloneDeep(initialState.settings) :
			{
				enableActionPlan: TOKEN_UTIL.hasSettingEnableActionPlan(_appSettingsOverride),
				enableClosureReport: TOKEN_UTIL.hasSettingEnableClosureReport(_appSettingsOverride),

				enableLinesListCardsView: TOKEN_UTIL.hasSettingEnableLinesListCardsView(_appSettingsOverride),
				enableLinesListTableView: TOKEN_UTIL.hasSettingEnableLinesListTableView(_appSettingsOverride),
				enableMyProjects: TOKEN_UTIL.hasSettingEnableMyProjects(_appSettingsOverride),

				enableReports: TOKEN_UTIL.hasSettingEnableReports(_appSettingsOverride),
				enableReportListActionPlanAndClosureV1: TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV1(_appSettingsOverride),
				enableReportListActionPlanAndClosureV2: TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV2(_appSettingsOverride),
				enableReportPercentPassing: TOKEN_UTIL.hasSettingEnableReportPercentPassing(_appSettingsOverride),
				enableReportTotalMiles: TOKEN_UTIL.hasSettingEnableReportTotalMiles(_appSettingsOverride),

				enableCustomerCreatedJobs: TOKEN_UTIL.hasSettingEnableCustomerCreatedJobs(_appSettingsOverride),
				defaultUploadsToSearchable: TOKEN_UTIL.hasSettingDefaultUploadsToSearchable(_appSettingsOverride),

				enableSharedStateForAnalysisAndReports: TOKEN_UTIL.hasSettingEnableSharedStateForAnalysisAndReports(_appSettingsOverride),
				autoRemoveIliData: TOKEN_UTIL.hasSettingAutoRemoveIliData(_appSettingsOverride),
				enablePsqlIliData: TOKEN_UTIL.hasSettingEnablePsqlIliData(_appSettingsOverride),
				enableTempUploadAutoRemove: TOKEN_UTIL.hasSettingEnableTempUploadAutoRemove(_appSettingsOverride),
				enablePersistLinkedSurveys: TOKEN_UTIL.hasSettingEnablePersistLinkedSurveys(_appSettingsOverride),
				featureClosureCopyActionPlan: TOKEN_UTIL.hasSettingFeatureClosureCopyActionPlan(_appSettingsOverride),
			};

    return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        settings
			}
		};
  }
};

export default reducerParts;
